import { css } from 'styled-components';

import { MenuTheme, SternumTheme } from '@sternum/ui';
import { Colors, Shadows } from '@sternum/web/components/theme/constants';

import { SBOMDarkTextInputTheme } from '../text-input/Dark.theme';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export function SBOMDarkMenuTheme(theme: SternumTheme): Partial<MenuTheme> {
  return {
    ...SBOMDarkTextInputTheme(theme).default,
    textColor: theme.textColor,
    menuActiveLabelTextColor: theme.textColor,
    backgroundColor: Colors.DarkerText,
    subMenuBackgroundColor: Colors.DarkerText,
    menuHoverBackgroundColor: Colors.DarkerText,
    borderRadius: '10px 10px 20px 20px',
    rightIconContainerPadding: '0',
    menuContainerCss: css`
      padding: 4px 0;
      border-radius: 4px;
      filter: drop-shadow(${Shadows.DialogDarkMode});
    `,
    menuItemContainerCss: css`
      padding: 0 16px;
      height: 34px;

      & p {
        font-size: 12px;
        line-height: 18px;
        color: ${theme.textColor};
      }
    `,
    subMenuContainerCss: css`
      padding: 6px 0;
      border-radius: 4px;
      filter: drop-shadow(${Shadows.DialogDarkMode});
    `,
  };
}
